module.exports = __webpack_public_path__ + "static/media/banner.c5ee0e21.png";